import { COMPANY_SETTINGS_PERMISSIONS } from './company-permissions.config';
import { canManageTeamFromPermissions, PermissionCheckFn } from './team-access';
import {
  ProfileConfigurationPlanGate,
  resolveProfileConfigurationLink,
} from './profile-configuration-link.utils';

/**
 * Quién ve el atajo / catálogo Gemas: misma audiencia que «Configuración» en el perfil
 * (no exige permisos de Usuarios/Roles).
 */
export function canAccessGemasLink(
  can?: PermissionCheckFn,
  plan?: ProfileConfigurationPlanGate
): boolean {
  return resolveProfileConfigurationLink(can, plan) !== null;
}

/** Entrada a `/account/gemas` cuando hay permiso de empresa o de equipo. Soft: sin `can` → true. */
export function canOpenGemasPage(can?: PermissionCheckFn): boolean {
  if (!can) {
    return true;
  }
  const company = COMPANY_SETTINGS_PERMISSIONS.show;
  if (can(company.resource, company.action)) {
    return true;
  }
  return canManageTeamFromPermissions(can);
}
